import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as reactReducerToastr } from 'react-redux-toastr';

import UserReducer from './user';
import sideBarReducer from './sidebar';
import ticketReducer from './ticket';
import modalServicesReducer from './modalServices';
import servicesReducer from './services';
import waitingTicketsReducer from './waitingTickets';
import forwardingModalReducer from './forwardingModal';
import ticketRatingModalReducer from './ticketRatingModal';

export default combineReducers({
  form: formReducer,
  toastr: reactReducerToastr,
  user: UserReducer,
  sideBar: sideBarReducer,
  ticket: ticketReducer,
  modalServices: modalServicesReducer,
  services: servicesReducer,
  waitingTickets: waitingTicketsReducer,
  forwardingModal: forwardingModalReducer,
  ticketRatingModal: ticketRatingModalReducer,
});
